export const FirebaseConfig = {
	"apiKey": "AIzaSyB1YXQwJg1WVmS3KWE6MpuXTVOQrp_o7R4",
	"authDomain": "klibs-409620.firebaseapp.com",
	"databaseURL": "https://klibs-409620-default-rtdb.firebaseio.com",
	"projectId": "klibs-409620",
	"storageBucket": "klibs-409620.firebasestorage.app",
	"messagingSenderId": "99600783689",
	"appId": "1:99600783689:web:5c1d6f148450b151b06298",
	"measurementId": "G-YCKR09XCTY"
}; 